var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.817 4.3623C11.917 4.3623 12.817 3.4623 12.817 2.3623C12.817 1.2623 11.917 0.362305 10.817 0.362305C9.71704 0.362305 8.81704 1.2623 8.81704 2.3623C8.81704 3.4623 9.71704 4.3623 10.817 4.3623ZM7.21704 18.2623L8.21704 13.8623L10.317 15.8623V21.8623H12.317V14.3623L10.217 12.3623L10.817 9.3623C12.117 10.8623 14.117 11.8623 16.317 11.8623V9.8623C14.417 9.8623 12.817 8.8623 12.017 7.4623L11.017 5.8623C10.617 5.2623 10.017 4.8623 9.31704 4.8623C9.01704 4.8623 8.81704 4.9623 8.51704 4.9623L3.31704 7.1623V11.8623H5.31704V8.46231L7.11704 7.7623L5.51704 15.8623L0.617041 14.8623L0.217041 16.8623L7.21704 18.2623Z",
    fill: "#FF891C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioHealthIcon);
export default __webpack_public_path__ + "static/media/portfolio-health-icon.3d0834d10cb174025cb474054e7e81c5.svg";
export { ForwardRef as ReactComponent };